<!--
 * @Author: natsu
 * @Date: 2020-03-31 16:44:57
 * @LastEditors: natsu
 * @LastEditTime: 2021-11-21 19:31:32
 * @Description: file content
-->
<script src="../../../../Recording 2_23_2023 at 5_59_33 PM.js"></script>
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>zcat SDK</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zcat/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "release",
          linkList: [
            ur + "release/zcat.browser.min.js",
            ur + "release/zcat.uni.min.js",
            ur + 'release/zcat.uni.es.min.js'
          ]
        },
        {
          label: "pre-release",
          linkList: [
            ur + "pre-release/zcat.browser.min.js",
            ur + "pre-release/zcat.uni.min.js"
          ]
        },
        {
          label: '2.8.0',
          linkList: [
            ur + '2.8.0/zcat.browser.min.js',
            ur + '2.8.0/zcat.uni.min.js',
            ur + '2.8.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.7.0',
          linkList: [
            ur + '2.7.0/zcat.browser.min.js',
            ur + '2.7.0/zcat.uni.min.js',
            ur + '2.7.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.6.0',
          linkList: [
            ur + '2.6.0/zcat.browser.min.js',
            ur + '2.6.0/zcat.uni.min.js',
            ur + '2.6.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.5.0',
          linkList: [
            ur + '2.5.0/zcat.browser.min.js',
            ur + '2.5.0/zcat.uni.min.js',
            ur + '2.5.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.4.0',
          linkList: [
            ur + '2.4.0/zcat.browser.min.js',
            ur + '2.4.0/zcat.uni.min.js',
            ur + '2.4.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.3.0',
          linkList: [
            ur + '2.3.0/zcat.browser.min.js',
            ur + '2.3.0/zcat.uni.min.js',
            ur + '2.3.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.2.0',
          linkList: [
            ur + '2.2.0/zcat.browser.min.js',
            ur + '2.2.0/zcat.uni.min.js',
            ur + '2.2.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.1.0',
          linkList: [
            ur + '2.1.0/zcat.browser.min.js',
            ur + '2.1.0/zcat.uni.min.js',
            ur + '2.1.0/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.42',
          linkList: [
            ur + '2.0.42/zcat.browser.min.js',
            ur + '2.0.42/zcat.uni.min.js',
            ur + '2.0.42/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.41',
          linkList: [
            ur + '2.0.41/zcat.browser.min.js',
            ur + '2.0.41/zcat.uni.min.js',
            ur + '2.0.41/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.40',
          linkList: [
            ur + '2.0.40/zcat.browser.min.js',
            ur + '2.0.40/zcat.uni.min.js',
            ur + '2.0.40/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.39',
          linkList: [
            ur + '2.0.39/zcat.browser.min.js',
            ur + '2.0.39/zcat.uni.min.js',
            ur + '2.0.39/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.38',
          linkList: [
            ur + '2.0.38/zcat.browser.min.js',
            ur + '2.0.38/zcat.uni.min.js',
            ur + '2.0.38/zcat.uni.es.min.js'
          ]
        },
        {
          label: '2.0.37',
          linkList: [
            ur + '2.0.37/zcat.browser.min.js',
            ur + '2.0.37/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.36',
          linkList: [
            ur + '2.0.36/zcat.browser.min.js',
            ur + '2.0.36/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.35',
          linkList: [
            ur + '2.0.35/zcat.browser.min.js',
            ur + '2.0.35/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.34',
          linkList: [
            ur + '2.0.34/zcat.browser.min.js',
            ur + '2.0.34/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.33',
          linkList: [
            ur + '2.0.33/zcat.browser.min.js',
            ur + '2.0.33/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.32',
          linkList: [
            ur + '2.0.32/zcat.browser.min.js',
            ur + '2.0.32/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.31',
          linkList: [
            ur + '2.0.31/zcat.browser.min.js',
            ur + '2.0.31/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.30',
          linkList: [
            ur + '2.0.30/zcat.browser.min.js',
            ur + '2.0.30/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.29',
          linkList: [
            ur + '2.0.29/zcat.browser.min.js',
            ur + '2.0.29/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.28',
          linkList: [
            ur + '2.0.28/zcat.browser.min.js',
            ur + '2.0.28/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.27',
          linkList: [
            ur + '2.0.27/zcat.browser.min.js',
            ur + '2.0.27/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.26',
          linkList: [
            ur + '2.0.26/zcat.browser.min.js',
            ur + '2.0.26/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.25',
          linkList: [
            ur + '2.0.25/zcat.browser.min.js',
            ur + '2.0.25/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.24',
          linkList: [
            ur + '2.0.24/zcat.browser.min.js',
            ur + '2.0.24/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.24',
          linkList: [
            ur + '2.0.24/zcat.browser.min.js',
            ur + '2.0.24/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.23',
          linkList: [
            ur + '2.0.23/zcat.browser.min.js',
            ur + '2.0.23/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.22',
          linkList: [
            ur + '2.0.22/zcat.browser.min.js',
            ur + '2.0.22/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.21',
          linkList: [
            ur + '2.0.21/zcat.browser.min.js',
            ur + '2.0.21/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.20',
          linkList: [
            ur + '2.0.20/zcat.browser.min.js',
            ur + '2.0.20/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.20',
          linkList: [
            ur + '2.0.20/zcat.browser.min.js',
            ur + '2.0.20/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.20',
          linkList: [
            ur + '2.0.20/zcat.browser.min.js',
            ur + '2.0.20/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.19',
          linkList: [
            ur + '2.0.19/zcat.browser.min.js',
            ur + '2.0.19/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.18',
          linkList: [
            ur + '2.0.18/zcat.browser.min.js',
            ur + '2.0.18/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.17',
          linkList: [
            ur + '2.0.17/zcat.browser.min.js',
            ur + '2.0.17/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.16',
          linkList: [
            ur + '2.0.16/zcat.browser.min.js',
            ur + '2.0.16/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.15',
          linkList: [
            ur + '2.0.15/zcat.browser.min.js',
            ur + '2.0.15/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.14',
          linkList: [
            ur + '2.0.14/zcat.browser.min.js',
            ur + '2.0.14/zcat.uni.min.js'
          ]
        },
        {
          label: '2.0.13',
          linkList: [
            ur + '2.0.13/zcat.browser.min.js',
            ur + '2.0.13/zcat.uni.min.js'
          ]
        },
        {
          label: "2.0.12",
          linkList: [
            ur + "2.0.12/zcat.browser.min.js",
            ur + "2.0.12/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.11",
          linkList: [
            ur + "2.0.11/zcat.browser.min.js",
            ur + "2.0.11/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.10",
          linkList: [
            ur + "2.0.10/zcat.browser.min.js",
            ur + "2.0.10/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.9",
          linkList: [
            ur + "2.0.9/zcat.browser.min.js",
            ur + "2.0.9/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.8",
          linkList: [
            ur + "2.0.8/zcat.browser.min.js",
            ur + "2.0.8/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.7",
          linkList: [
            ur + "2.0.7/zcat.browser.min.js",
            ur + "2.0.7/zcat.wx.min.js",
            ur + "2.0.7/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.6",
          linkList: [
            ur + "2.0.6/zcat.browser.min.js",
            ur + "2.0.6/zcat.wx.min.js",
            ur + "2.0.6/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.5",
          linkList: [
            ur + "2.0.5/zcat.browser.min.js",
            ur + "2.0.5/zcat.wx.min.js",
            ur + "2.0.5/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.4",
          linkList: [
            ur + "2.0.4/zcat.browser.min.js",
            ur + "2.0.4/zcat.wx.min.js",
            ur + "2.0.4/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.3",
          linkList: [
            ur + "2.0.3/zcat.browser.min.js",
            ur + "2.0.3/zcat.wx.min.js",
            ur + "2.0.3/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.2",
          linkList: [
            ur + "2.0.2/zcat.browser.min.js",
            ur + "2.0.2/zcat.wx.min.js",
            ur + "2.0.2/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.1",
          linkList: [
            ur + "2.0.1/zcat.browser.min.js",
            ur + "2.0.1/zcat.wx.min.js",
            ur + "2.0.1/zcat.uni.min.js"
          ]
        },
        {
          label: "2.0.0",
          linkList: [
            ur + "2.0.0/zcat.browser.min.js",
            ur + "2.0.0/zcat.wx.min.js",
            ur + "2.0.0/zcat.uni.min.js"
          ]
        },
        {
          label: "1.0.6",
          linkList: [ur + "1.0.6/zcat-sdk.js", ur + "1.0.6/zcat-sdk.min.js"]
        },
        {
          label: "1.0.5",
          linkList: [ur + "1.0.5/zcat-sdk.js", ur + "1.0.5/zcat-sdk.min.js"]
        },
        {
          label: "1.0.4",
          linkList: [ur + "1.0.4/zcat-sdk.js", ur + "1.0.4/zcat-sdk.min.js"]
        },
        {
          label: "1.0.3",
          linkList: [ur + "1.0.3/zcat-sdk.js", ur + "1.0.3/zcat-sdk.min.js"]
        },
        {
          label: "1.0.2",
          linkList: [ur + "1.0.2/zcat-sdk.js", ur + "1.0.2/zcat-sdk.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZcat.vue